export function createExportButtonsFeature({
  exportService,
  galerieFeature,
  getPunchlineAnimLine,
  getLastOutput,
  input,
  normalizeFilename,
  loadFont,
  generateSVG,
}) {
  async function exportStickerSheet(format, buttonEl) {
    const text = input.value.trim();
    if (!text) return;
    if (typeof loadFont !== 'function' || typeof generateSVG !== 'function') {
      return;
    }

    const { createStickerPunchlinePngBlob } = await import('../stickers/stickerSheet.js');
    buttonEl.disabled = true;
    try {
      const fontBuffer = await loadFont();
      const blob = await createStickerPunchlinePngBlob({
        text,
        fontBuffer,
        generateSVG,
        format,
        transparentBetweenPunchlines: true,
      });
      const suffix = format === 'strip' ? '-sticker-15x3.75-300dpi' : '-sticker-5.5x5.5-300dpi';
      const name = `${normalizeFilename(text) || 'sticker'}${suffix}.png`;
      exportService.downloadBlob(blob, name);
    } finally {
      buttonEl.disabled = false;
    }
  }

  function rebuildVertical() {
    const btnsEl       = document.getElementById('dashboard-export-vertical-btns');
    const galerieLines = galerieFeature.getDashboardLines();

    document.getElementById('dashboard-export-section').hidden = galerieLines.length === 0;
    btnsEl.innerHTML = '';
    if (galerieLines.length === 0) return;

    exportService.groupGalerieByPage(galerieLines).forEach((group, idx) => {
      const pageNum  = idx + 1;
      const item     = document.createElement('div');
      item.className = 'dashboard-export-vertical-item';
      const btn      = document.createElement('button');
      btn.className  = 'dash-btn';
      btn.textContent = `${pageNum}`;
      const statusEl     = document.createElement('span');
      statusEl.className = 'dash-export-status';

      btn.addEventListener('click', async () => {
        btnsEl.querySelectorAll('button').forEach(b => { b.disabled = true; });
        try {
          await exportService.exportVerticalGroup({ group, pageNum, statusEl });
        } catch (err) {
          console.error('Erreur export vidéo:', err);
          statusEl.textContent = 'Erreur.';
        } finally {
          btnsEl.querySelectorAll('button').forEach(b => { b.disabled = false; });
        }
      });

      item.appendChild(btn);
      item.appendChild(statusEl);
      btnsEl.appendChild(item);
    });
  }

  function rebuildHorizontal() {
    const btnsEl       = document.getElementById('dashboard-export-horizontal-btns');
    const galerieLines = galerieFeature.getDashboardLines();

    btnsEl.innerHTML = '';
    if (galerieLines.length === 0) return;

    exportService.groupGalerieByPageHoriz(galerieLines).forEach((group, idx) => {
      const pageNum  = idx + 1;
      const item     = document.createElement('div');
      item.className = 'dashboard-export-horizontal-item';
      const btn      = document.createElement('button');
      btn.className  = 'dash-btn';
      btn.textContent = `${pageNum}`;
      const statusEl     = document.createElement('span');
      statusEl.className = 'dash-export-status';

      btn.addEventListener('click', async () => {
        btnsEl.querySelectorAll('button').forEach(b => { b.disabled = true; });
        try {
          await exportService.exportHorizontalGroup({ group, pageNum, statusEl });
        } catch (err) {
          console.error('Erreur export vidéo:', err);
          statusEl.textContent = 'Erreur.';
        } finally {
          btnsEl.querySelectorAll('button').forEach(b => { b.disabled = false; });
        }
      });

      item.appendChild(btn);
      item.appendChild(statusEl);
      btnsEl.appendChild(item);
    });
  }

  function bindProposerExports() {
    const exportBtn     = document.getElementById('exportBtn');
    const exportBtnDark = document.getElementById('exportBtnDark');
    const exportStatus  = document.getElementById('exportStatus');
    const exportStickerSquareBtn = document.getElementById('exportStickerSquareBtn');
    const exportStickerStripBtn = document.getElementById('exportStickerStripBtn');

    document.getElementById('exportSvgBtn').addEventListener('click', () => {
      const { svg, name } = getLastOutput();
      if (!svg) return;
      exportService.downloadSVG(svg, name);
    });

    document.getElementById('exportPngBtn').addEventListener('click', async () => {
      const { svg, name } = getLastOutput();
      if (!svg) return;
      await exportService.downloadPNG(svg, name.replace(/\.svg$/, '.png'));
    });

    exportStickerSquareBtn?.addEventListener('click', () => {
      void exportStickerSheet('square', exportStickerSquareBtn);
    });

    exportStickerStripBtn?.addEventListener('click', () => {
      void exportStickerSheet('strip', exportStickerStripBtn);
    });

    exportBtn.addEventListener('click', () => {
      const line = getPunchlineAnimLine();
      if (!line) { exportStatus.textContent = 'Lance d\'abord l\'animation.'; return; }
      exportService.doExportMP4({
        lineData:    line.data,
        filename:    normalizeFilename(input.value.trim()) || 'nocode-animation',
        bg: '#ffffff', fg: '#000000', suffix: '', dir: 1,
        statusEl: exportStatus, btn: exportBtn, otherBtn: exportBtnDark,
      });
    });

    exportBtnDark.addEventListener('click', () => {
      const line = getPunchlineAnimLine();
      if (!line) { exportStatus.textContent = 'Lance d\'abord l\'animation.'; return; }
      exportService.doExportMP4({
        lineData:    line.data,
        filename:    normalizeFilename(input.value.trim()) || 'nocode-animation',
        bg: '#000000', fg: '#ffffff', suffix: '-noir', dir: -1,
        statusEl: exportStatus, btn: exportBtnDark, otherBtn: exportBtn,
      });
    });
  }

  return { rebuildVertical, rebuildHorizontal, bindProposerExports };
}
